import samLoader from '../../assets/sam/sam_loader.gif';
import { LoadingFakeProgressBar } from './LoadingFakeProgressBar.tsx';
import { LoadingScreen } from './LoadingScreen.tsx';
import { LongLoaderProps } from './types.ts';

type LoadingScreenSamProps = {
  what?: string;
  fadeIn?: boolean;
  lightText?: boolean;
  overrideText?: string;
  longLoaderProps?: LongLoaderProps;
};

export const LoadingScreenSam = ({ fadeIn, longLoaderProps, ...props }: LoadingScreenSamProps) => (
  <LoadingScreen
    logoSrc={samLoader}
    logoWidth="250px"
    animationClassName={
      fadeIn ? 'loading-screen-animation-fade-in-250ms' : 'loading-screen-animation-none'
    }
    overrideComponent={
      longLoaderProps ? <LoadingFakeProgressBar {...longLoaderProps} /> : undefined
    }
    {...props}
  />
);
